/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { If, Then, Else } from "react-if";
import { Link } from "react-router-dom";
import { Text, theme } from "@nordcloud/gnui";
import { isNil } from "~/tools";

type Props = {
  environment?: {
    name: string;
    id: string;
    application: {
      name: string;
      id: string;
      nid: string;
    };
  };
  assignments?: {
    appCount: number;
    envCount: number;
  };
};

export function ApplicationCell({ assignments, environment }: Props) {
  const hideAssignments =
    assignments == null ||
    (assignments.appCount < 2 && assignments.envCount < 2);

  if (environment && hideAssignments) {
    return (
      <>
        <Link
          style={{ display: "block" }}
          to={`/applications/${environment.application.id}`}
        >
          {environment.application.name}
        </Link>
        <Link
          style={{ fontSize: "0.75rem", display: "block" }}
          to={`/applications/${environment.application.id}/${environment.id}`}
        >
          {environment.name}
        </Link>
      </>
    );
  }

  if (isNil(assignments)) {
    return null;
  }

  const hasApps = assignments.appCount !== 0;

  return (
    <If condition={hasApps}>
      <Then>
        <Text tag="div">{assignments.appCount} applications</Text>
        <Text size="sm" tag="div" color={theme.color.text.text02}>
          {assignments.envCount} environments
        </Text>
      </Then>
      <Else>
        <Text tag="div">Unallocated</Text>
      </Else>
    </If>
  );
}
